import { Checkbox, Field, Space, Text } from "@app/ui";
import { useT } from "../i18n.js";
import type { AccessGrantRole } from "../types.js";

const ROLES: AccessGrantRole[] = ["repairer", "recycler", "customs", "partner", "refurbisher", "distributor"];

/**
 * "Who can see this" for a restricted-tier item (EN 18239 / draft TR ESPR
 * Art. 13(1)(b)): none checked = every restricted role. The competent
 * authority is not listed — it always sees everything.
 */
export function AudienceField({
  value,
  onChange,
  disabled,
}: {
  value: AccessGrantRole[];
  onChange: (next: AccessGrantRole[]) => void;
  disabled?: boolean;
}) {
  const t = useT();
  return (
    <Field label={t("audience.label")} help={t("audience.help")}>
      <Space wrap>
        {ROLES.map((role) => (
          <Checkbox
            key={role}
            disabled={disabled}
            checked={value.includes(role)}
            onChange={(e) => onChange(e.target.checked ? [...value, role] : value.filter((r) => r !== role))}
          >
            {t(`accessRole.${role}`)}
          </Checkbox>
        ))}
        {value.length === 0 && (
          <Text small secondary>
            {t("audience.everyone")}
          </Text>
        )}
      </Space>
    </Field>
  );
}
